import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'executive-report-api.vendasta-local.com',
  'test': '',
  'demo': 'executive-report-demo.apigateway.co',
  'prod': 'executive-report-prod.apigateway.co',
  'production': 'executive-report-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(t) {
    return new (t || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var Category = /*#__PURE__*/function (Category) {
  Category[Category["NOT_SPECIFIED"] = 0] = "NOT_SPECIFIED";
  Category[Category["LISTINGS"] = 1] = "LISTINGS";
  Category[Category["REPUTATION"] = 2] = "REPUTATION";
  Category[Category["SOCIAL"] = 3] = "SOCIAL";
  Category[Category["WEBSITE"] = 4] = "WEBSITE";
  Category[Category["SEO"] = 5] = "SEO";
  Category[Category["ADVERTISING"] = 6] = "ADVERTISING";
  Category[Category["CONTENT_AND_EXPERIENCE"] = 7] = "CONTENT_AND_EXPERIENCE";
  Category[Category["ACCOUNTING"] = 8] = "ACCOUNTING";
  Category[Category["ECOMMERCE"] = 9] = "ECOMMERCE";
  Category[Category["OTHER"] = 10] = "OTHER";
  return Category;
}(Category || {});
var Color = /*#__PURE__*/function (Color) {
  Color[Color["COLOR_NOT_SPECIFIED"] = 0] = "COLOR_NOT_SPECIFIED";
  Color[Color["BLACK"] = 1] = "BLACK";
  Color[Color["WHITE"] = 2] = "WHITE";
  Color[Color["GRAY"] = 3] = "GRAY";
  Color[Color["RED"] = 4] = "RED";
  Color[Color["GREEN"] = 5] = "GREEN";
  Color[Color["BLUE"] = 6] = "BLUE";
  Color[Color["YELLOW"] = 7] = "YELLOW";
  Color[Color["PURPLE"] = 8] = "PURPLE";
  Color[Color["ORANGE"] = 9] = "ORANGE";
  return Color;
}(Color || {});
var ReportDataFormat = /*#__PURE__*/function (ReportDataFormat) {
  ReportDataFormat[ReportDataFormat["NUMBER"] = 0] = "NUMBER";
  ReportDataFormat[ReportDataFormat["PERCENT"] = 1] = "PERCENT";
  ReportDataFormat[ReportDataFormat["TIME"] = 3] = "TIME";
  ReportDataFormat[ReportDataFormat["FRACTION"] = 4] = "FRACTION";
  return ReportDataFormat;
}(ReportDataFormat || {});
var ReportDataGrade = /*#__PURE__*/function (ReportDataGrade) {
  ReportDataGrade[ReportDataGrade["NONE_SPECIFIED"] = 0] = "NONE_SPECIFIED";
  ReportDataGrade[ReportDataGrade["A"] = 1] = "A";
  ReportDataGrade[ReportDataGrade["B"] = 2] = "B";
  ReportDataGrade[ReportDataGrade["C"] = 3] = "C";
  ReportDataGrade[ReportDataGrade["D"] = 4] = "D";
  ReportDataGrade[ReportDataGrade["F"] = 5] = "F";
  return ReportDataGrade;
}(ReportDataGrade || {});
var ReportFrequency = /*#__PURE__*/function (ReportFrequency) {
  ReportFrequency[ReportFrequency["FREQUENCY_NOT_SPECIFIED"] = 0] = "FREQUENCY_NOT_SPECIFIED";
  ReportFrequency[ReportFrequency["WEEKLY"] = 1] = "WEEKLY";
  ReportFrequency[ReportFrequency["MONTHLY"] = 2] = "MONTHLY";
  return ReportFrequency;
}(ReportFrequency || {});
var ReportDataTemplateType = /*#__PURE__*/function (ReportDataTemplateType) {
  ReportDataTemplateType[ReportDataTemplateType["NOT_SPECIFIED"] = 0] = "NOT_SPECIFIED";
  ReportDataTemplateType[ReportDataTemplateType["NUMBER_WITH_CHANGE"] = 1] = "NUMBER_WITH_CHANGE";
  ReportDataTemplateType[ReportDataTemplateType["CALL_TO_ACTION"] = 2] = "CALL_TO_ACTION";
  ReportDataTemplateType[ReportDataTemplateType["BASIC_LIST"] = 3] = "BASIC_LIST";
  ReportDataTemplateType[ReportDataTemplateType["INFO_LIST"] = 4] = "INFO_LIST";
  ReportDataTemplateType[ReportDataTemplateType["BAR_CHART"] = 5] = "BAR_CHART";
  ReportDataTemplateType[ReportDataTemplateType["BASIC_NUMBER"] = 6] = "BASIC_NUMBER";
  ReportDataTemplateType[ReportDataTemplateType["THERMOMETER_WITH_GRADE"] = 7] = "THERMOMETER_WITH_GRADE";
  ReportDataTemplateType[ReportDataTemplateType["LINE_GRAPH"] = 8] = "LINE_GRAPH";
  ReportDataTemplateType[ReportDataTemplateType["WORD_CLOUD"] = 9] = "WORD_CLOUD";
  return ReportDataTemplateType;
}(ReportDataTemplateType || {});
var ReportDataWidth = /*#__PURE__*/function (ReportDataWidth) {
  ReportDataWidth[ReportDataWidth["HALF"] = 0] = "HALF";
  ReportDataWidth[ReportDataWidth["FULL"] = 1] = "FULL";
  ReportDataWidth[ReportDataWidth["QUARTER"] = 2] = "QUARTER";
  return ReportDataWidth;
}(ReportDataWidth || {});
// *********************************

function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class BarChart {
  static fromProto(proto) {
    let m = new BarChart();
    m = Object.assign(m, proto);
    if (proto.fillPercent) {
      m.fillPercent = parseInt(proto.fillPercent, 10);
    }
    if (proto.fillColor) {
      m.fillColor = enumStringToValue$1(Color, proto.fillColor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.fillPercent !== 'undefined') {
      toReturn['fillPercent'] = this.fillPercent;
    }
    if (typeof this.fillColor !== 'undefined') {
      toReturn['fillColor'] = this.fillColor;
    }
    return toReturn;
  }
}
class GetReportConfigRequest {
  static fromProto(proto) {
    let m = new GetReportConfigRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class GetReportConfigResponse {
  static fromProto(proto) {
    let m = new GetReportConfigResponse();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = ReportConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class GetReportSummaryRequest {
  static fromProto(proto) {
    let m = new GetReportSummaryRequest();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$1(ReportFrequency, proto.frequency);
    }
    if (proto.reportDate) {
      m.reportDate = new Date(proto.reportDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.reportDate !== 'undefined' && this.reportDate !== null) {
      toReturn['reportDate'] = 'toApiJson' in this.reportDate ? this.reportDate.toApiJson() : this.reportDate;
    }
    return toReturn;
  }
}
class GetReportSummaryResponse {
  static fromProto(proto) {
    let m = new GetReportSummaryResponse();
    m = Object.assign(m, proto);
    if (proto.positive) {
      m.positive = proto.positive.map(HighlightItem.fromProto);
    }
    if (proto.negative) {
      m.negative = proto.negative.map(HighlightItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.positive !== 'undefined' && this.positive !== null) {
      toReturn['positive'] = 'toApiJson' in this.positive ? this.positive.toApiJson() : this.positive;
    }
    if (typeof this.negative !== 'undefined' && this.negative !== null) {
      toReturn['negative'] = 'toApiJson' in this.negative ? this.negative.toApiJson() : this.negative;
    }
    return toReturn;
  }
}
class GraphMarker {
  static fromProto(proto) {
    let m = new GraphMarker();
    m = Object.assign(m, proto);
    if (proto.percentile) {
      m.percentile = parseInt(proto.percentile, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    if (typeof this.percentile !== 'undefined') {
      toReturn['percentile'] = this.percentile;
    }
    return toReturn;
  }
}
class HighlightItem {
  static fromProto(proto) {
    let m = new HighlightItem();
    m = Object.assign(m, proto);
    if (proto.i18n) {
      m.i18n = Object.keys(proto.i18n).reduce((obj, k) => {
        obj[k] = proto.i18n[k];
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.highlight !== 'undefined') {
      toReturn['highlight'] = this.highlight;
    }
    if (typeof this.anchorLink !== 'undefined') {
      toReturn['anchorLink'] = this.anchorLink;
    }
    if (typeof this.i18n !== 'undefined' && this.i18n !== null) {
      toReturn['i18n'] = 'toApiJson' in this.i18n ? this.i18n.toApiJson() : this.i18n;
    }
    return toReturn;
  }
}
class HighlightItemI18nEntry {
  static fromProto(proto) {
    let m = new HighlightItemI18nEntry();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class LineGraph {
  static fromProto(proto) {
    let m = new LineGraph();
    m = Object.assign(m, proto);
    if (proto.point) {
      m.point = proto.point.map(Point2D.fromProto);
    }
    if (proto.fillColor) {
      m.fillColor = enumStringToValue$1(Color, proto.fillColor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.point !== 'undefined' && this.point !== null) {
      toReturn['point'] = 'toApiJson' in this.point ? this.point.toApiJson() : this.point;
    }
    if (typeof this.fillColor !== 'undefined') {
      toReturn['fillColor'] = this.fillColor;
    }
    return toReturn;
  }
}
class ListItem {
  static fromProto(proto) {
    let m = new ListItem();
    m = Object.assign(m, proto);
    if (proto.infoTextColor) {
      m.infoTextColor = enumStringToValue$1(Color, proto.infoTextColor);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.header !== 'undefined') {
      toReturn['header'] = this.header;
    }
    if (typeof this.body !== 'undefined') {
      toReturn['body'] = this.body;
    }
    if (typeof this.footer !== 'undefined') {
      toReturn['footer'] = this.footer;
    }
    if (typeof this.infoText !== 'undefined') {
      toReturn['infoText'] = this.infoText;
    }
    if (typeof this.infoTextColor !== 'undefined') {
      toReturn['infoTextColor'] = this.infoTextColor;
    }
    if (typeof this.infoTextIcon !== 'undefined') {
      toReturn['infoTextIcon'] = this.infoTextIcon;
    }
    if (typeof this.imageUrl !== 'undefined') {
      toReturn['imageUrl'] = this.imageUrl;
    }
    return toReturn;
  }
}
class ListReportDataPagedResponse {
  static fromProto(proto) {
    let m = new ListReportDataPagedResponse();
    m = Object.assign(m, proto);
    if (proto.reportData) {
      m.reportData = proto.reportData.map(ProductReportEntity.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reportData !== 'undefined' && this.reportData !== null) {
      toReturn['reportData'] = 'toApiJson' in this.reportData ? this.reportData.toApiJson() : this.reportData;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    return toReturn;
  }
}
class ListReportDataRequest {
  static fromProto(proto) {
    let m = new ListReportDataRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$1(Category, proto.category);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$1(ReportFrequency, proto.frequency);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.reportDate) {
      m.reportDate = new Date(proto.reportDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.reportDate !== 'undefined' && this.reportDate !== null) {
      toReturn['reportDate'] = 'toApiJson' in this.reportDate ? this.reportDate.toApiJson() : this.reportDate;
    }
    return toReturn;
  }
}
class ListReportDatesRequest {
  static fromProto(proto) {
    let m = new ListReportDatesRequest();
    m = Object.assign(m, proto);
    if (proto.frequency) {
      m.frequency = enumStringToValue$1(ReportFrequency, proto.frequency);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListReportDatesResponse {
  static fromProto(proto) {
    let m = new ListReportDatesResponse();
    m = Object.assign(m, proto);
    if (proto.reportDates) {
      m.reportDates = proto.reportDates.map(d => new Date(d));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.reportDates !== 'undefined' && this.reportDates !== null) {
      toReturn['reportDates'] = 'toApiJson' in this.reportDates ? this.reportDates.toApiJson() : this.reportDates;
    }
    if (typeof this.hasNext !== 'undefined') {
      toReturn['hasNext'] = this.hasNext;
    }
    if (typeof this.hasPrev !== 'undefined') {
      toReturn['hasPrev'] = this.hasPrev;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.prevCursor !== 'undefined') {
      toReturn['prevCursor'] = this.prevCursor;
    }
    return toReturn;
  }
}
class Point2D {
  static fromProto(proto) {
    let m = new Point2D();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.x !== 'undefined') {
      toReturn['x'] = this.x;
    }
    if (typeof this.y !== 'undefined') {
      toReturn['y'] = this.y;
    }
    return toReturn;
  }
}
class ProductReportEntity {
  static fromProto(proto) {
    let m = new ProductReportEntity();
    m = Object.assign(m, proto);
    if (proto.data) {
      m.data = proto.data.map(ReportData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.data !== 'undefined' && this.data !== null) {
      toReturn['data'] = 'toApiJson' in this.data ? this.data.toApiJson() : this.data;
    }
    if (typeof this.marketplaceAppId !== 'undefined') {
      toReturn['marketplaceAppId'] = this.marketplaceAppId;
    }
    return toReturn;
  }
}
class ReportConfig {
  static fromProto(proto) {
    let m = new ReportConfig();
    m = Object.assign(m, proto);
    if (proto.enabledCategories) {
      m.enabledCategories = proto.enabledCategories.map(v => enumStringToValue$1(Category, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.enabledCategories !== 'undefined') {
      toReturn['enabledCategories'] = this.enabledCategories;
    }
    return toReturn;
  }
}
class ReportData {
  static fromProto(proto) {
    let m = new ReportData();
    m = Object.assign(m, proto);
    if (proto.templateType) {
      m.templateType = enumStringToValue$1(ReportDataTemplateType, proto.templateType);
    }
    if (proto.format) {
      m.format = enumStringToValue$1(ReportDataFormat, proto.format);
    }
    if (proto.precision) {
      m.precision = parseInt(proto.precision, 10);
    }
    if (proto.width) {
      m.width = enumStringToValue$1(ReportDataWidth, proto.width);
    }
    if (proto.list) {
      m.list = proto.list.map(ListItem.fromProto);
    }
    if (proto.barChart) {
      m.barChart = proto.barChart.map(BarChart.fromProto);
    }
    if (proto.marker) {
      m.marker = proto.marker.map(GraphMarker.fromProto);
    }
    if (proto.grade) {
      m.grade = enumStringToValue$1(ReportDataGrade, proto.grade);
    }
    if (proto.lineGraph) {
      m.lineGraph = proto.lineGraph.map(LineGraph.fromProto);
    }
    if (proto.createdOn) {
      m.createdOn = new Date(proto.createdOn);
    }
    if (proto.wordCloudList) {
      m.wordCloudList = proto.wordCloudList.map(WordCloudItem.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.templateType !== 'undefined') {
      toReturn['templateType'] = this.templateType;
    }
    if (typeof this.uniqueId !== 'undefined') {
      toReturn['uniqueId'] = this.uniqueId;
    }
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    if (typeof this.change !== 'undefined') {
      toReturn['change'] = this.change;
    }
    if (typeof this.format !== 'undefined') {
      toReturn['format'] = this.format;
    }
    if (typeof this.precision !== 'undefined') {
      toReturn['precision'] = this.precision;
    }
    if (typeof this.width !== 'undefined') {
      toReturn['width'] = this.width;
    }
    if (typeof this.nextUrl !== 'undefined') {
      toReturn['nextUrl'] = this.nextUrl;
    }
    if (typeof this.nextUrlLabel !== 'undefined') {
      toReturn['nextUrlLabel'] = this.nextUrlLabel;
    }
    if (typeof this.list !== 'undefined' && this.list !== null) {
      toReturn['list'] = 'toApiJson' in this.list ? this.list.toApiJson() : this.list;
    }
    if (typeof this.barChart !== 'undefined' && this.barChart !== null) {
      toReturn['barChart'] = 'toApiJson' in this.barChart ? this.barChart.toApiJson() : this.barChart;
    }
    if (typeof this.marker !== 'undefined' && this.marker !== null) {
      toReturn['marker'] = 'toApiJson' in this.marker ? this.marker.toApiJson() : this.marker;
    }
    if (typeof this.grade !== 'undefined') {
      toReturn['grade'] = this.grade;
    }
    if (typeof this.lineGraph !== 'undefined' && this.lineGraph !== null) {
      toReturn['lineGraph'] = 'toApiJson' in this.lineGraph ? this.lineGraph.toApiJson() : this.lineGraph;
    }
    if (typeof this.createdOn !== 'undefined' && this.createdOn !== null) {
      toReturn['createdOn'] = 'toApiJson' in this.createdOn ? this.createdOn.toApiJson() : this.createdOn;
    }
    if (typeof this.initialValue !== 'undefined') {
      toReturn['initialValue'] = this.initialValue;
    }
    if (typeof this.wordCloudList !== 'undefined' && this.wordCloudList !== null) {
      toReturn['wordCloudList'] = 'toApiJson' in this.wordCloudList ? this.wordCloudList.toApiJson() : this.wordCloudList;
    }
    return toReturn;
  }
}
class ReportDataRequest {
  static fromProto(proto) {
    let m = new ReportDataRequest();
    m = Object.assign(m, proto);
    if (proto.category) {
      m.category = enumStringToValue$1(Category, proto.category);
    }
    if (proto.frequency) {
      m.frequency = enumStringToValue$1(ReportFrequency, proto.frequency);
    }
    if (proto.reportData) {
      m.reportData = proto.reportData.map(ReportData.fromProto);
    }
    if (proto.reportDate) {
      m.reportDate = new Date(proto.reportDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.category !== 'undefined') {
      toReturn['category'] = this.category;
    }
    if (typeof this.frequency !== 'undefined') {
      toReturn['frequency'] = this.frequency;
    }
    if (typeof this.reportData !== 'undefined' && this.reportData !== null) {
      toReturn['reportData'] = 'toApiJson' in this.reportData ? this.reportData.toApiJson() : this.reportData;
    }
    if (typeof this.reportDate !== 'undefined' && this.reportDate !== null) {
      toReturn['reportDate'] = 'toApiJson' in this.reportDate ? this.reportDate.toApiJson() : this.reportDate;
    }
    if (typeof this.marketplaceAppId !== 'undefined') {
      toReturn['marketplaceAppId'] = this.marketplaceAppId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class SaveReportConfigRequest {
  static fromProto(proto) {
    let m = new SaveReportConfigRequest();
    m = Object.assign(m, proto);
    if (proto.config) {
      m.config = ReportConfig.fromProto(proto.config);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.config !== 'undefined' && this.config !== null) {
      toReturn['config'] = 'toApiJson' in this.config ? this.config.toApiJson() : this.config;
    }
    return toReturn;
  }
}
class WordCloudItem {
  static fromProto(proto) {
    let m = new WordCloudItem();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.text !== 'undefined') {
      toReturn['text'] = this.text;
    }
    if (typeof this.sentiment !== 'undefined') {
      toReturn['sentiment'] = this.sentiment;
    }
    if (typeof this.weight !== 'undefined') {
      toReturn['weight'] = this.weight;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ListActiveAppsMetadataResponseAppMetadatum {
  static fromProto(proto) {
    let m = new ListActiveAppsMetadataResponseAppMetadatum();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class ListActiveAppsMetadataRequest {
  static fromProto(proto) {
    let m = new ListActiveAppsMetadataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.jwtId !== 'undefined') {
      toReturn['jwtId'] = this.jwtId;
    }
    return toReturn;
  }
}
class ListActiveAppsMetadataResponse {
  static fromProto(proto) {
    let m = new ListActiveAppsMetadataResponse();
    m = Object.assign(m, proto);
    if (proto.appMetadata) {
      m.appMetadata = proto.appMetadata.map(ListActiveAppsMetadataResponseAppMetadatum.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appMetadata !== 'undefined' && this.appMetadata !== null) {
      toReturn['appMetadata'] = 'toApiJson' in this.appMetadata ? this.appMetadata.toApiJson() : this.appMetadata;
    }
    return toReturn;
  }
}
class ListActiveAppsRequest {
  static fromProto(proto) {
    let m = new ListActiveAppsRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.jwtId !== 'undefined') {
      toReturn['jwtId'] = this.jwtId;
    }
    return toReturn;
  }
}
class ListActiveAppsResponse {
  static fromProto(proto) {
    let m = new ListActiveAppsResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appIds !== 'undefined') {
      toReturn['appIds'] = this.appIds;
    }
    return toReturn;
  }
}

// *********************************

// *********************************
let ConfigurationApiService = /*#__PURE__*/(() => {
  class ConfigurationApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listActiveApps(r) {
      const request = r.toApiJson ? r : new ListActiveAppsRequest(r);
      return this.http.post(this._host + "/executivereport.v1.Configuration/ListActiveApps", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActiveAppsResponse.fromProto(resp)));
    }
    listActiveAppsMetadata(r) {
      const request = r.toApiJson ? r : new ListActiveAppsMetadataRequest(r);
      return this.http.post(this._host + "/executivereport.v1.Configuration/ListActiveAppsMetadata", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListActiveAppsMetadataResponse.fromProto(resp)));
    }
  }
  ConfigurationApiService.ɵfac = function ConfigurationApiService_Factory(t) {
    return new (t || ConfigurationApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ConfigurationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ConfigurationApiService,
    factory: ConfigurationApiService.ɵfac,
    providedIn: 'root'
  });
  return ConfigurationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ExecutiveReportApiService = /*#__PURE__*/(() => {
  class ExecutiveReportApiService {
    constructor(http, hostService) {
      this.http = http;
      this.hostService = hostService;
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createReportData(r) {
      const request = r.toApiJson ? r : new ReportDataRequest(r);
      return this.http.post(this._host + "/executivereport.v1.ExecutiveReport/CreateReportData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    listReportData(r) {
      const request = r.toApiJson ? r : new ListReportDataRequest(r);
      return this.http.post(this._host + "/executivereport.v1.ExecutiveReport/ListReportData", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListReportDataPagedResponse.fromProto(resp)));
    }
    listReportDates(r) {
      const request = r.toApiJson ? r : new ListReportDatesRequest(r);
      return this.http.post(this._host + "/executivereport.v1.ExecutiveReport/ListReportDates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListReportDatesResponse.fromProto(resp)));
    }
    getReportSummary(r) {
      const request = r.toApiJson ? r : new GetReportSummaryRequest(r);
      return this.http.post(this._host + "/executivereport.v1.ExecutiveReport/GetReportSummary", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReportSummaryResponse.fromProto(resp)));
    }
    saveReportConfig(r) {
      const request = r.toApiJson ? r : new SaveReportConfigRequest(r);
      return this.http.post(this._host + "/executivereport.v1.ExecutiveReport/SaveReportConfig", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getReportConfig(r) {
      const request = r.toApiJson ? r : new GetReportConfigRequest(r);
      return this.http.post(this._host + "/executivereport.v1.ExecutiveReport/GetReportConfig", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetReportConfigResponse.fromProto(resp)));
    }
  }
  ExecutiveReportApiService.ɵfac = function ExecutiveReportApiService_Factory(t) {
    return new (t || ExecutiveReportApiService)(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(HostService));
  };
  ExecutiveReportApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ExecutiveReportApiService,
    factory: ExecutiveReportApiService.ɵfac,
    providedIn: 'root'
  });
  return ExecutiveReportApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
let ExecutiveReportService = /*#__PURE__*/(() => {
  class ExecutiveReportService {
    constructor(api) {
      this.api = api;
    }
    createReportData(category, frequency, reportData, reportDate, marketplaceAppId, accountGroupId) {
      const req = new ReportDataRequest({
        category: category,
        frequency: frequency,
        reportData: reportData,
        reportDate: reportDate,
        marketplaceAppId: marketplaceAppId,
        accountGroupId: accountGroupId
      });
      return this.api.createReportData(req).pipe(map(() => true));
    }
    listReportData(category, frequency, cursor, pageSize, accountGroupId, reportDate) {
      const req = new ListReportDataRequest({
        category: category,
        frequency: frequency,
        cursor: cursor,
        pageSize: pageSize,
        accountGroupId: accountGroupId,
        reportDate: reportDate
      });
      return this.api.listReportData(req).pipe(map(resp => new PagedResponse(resp.reportData, resp.nextCursor, resp.hasMore)));
    }
    listReportDates(accountGroupId, frequency, cursor, pageSize) {
      const req = new ListReportDatesRequest({
        accountGroupId: accountGroupId,
        frequency: frequency,
        cursor: cursor,
        pageSize: pageSize
      });
      return this.api.listReportDates(req).pipe(map(resp => new BiDirectionalPagedResponse(resp.reportDates, resp.nextCursor, resp.prevCursor, resp.hasNext, resp.hasPrev)));
    }
    getReportSummary(frequency, accountGroupId, reportDate) {
      const req = new GetReportSummaryRequest({
        frequency: frequency,
        accountGroupId: accountGroupId,
        reportDate: reportDate
      });
      return this.api.getReportSummary(req).pipe(map(resp => new GetReportSummaryResponse({
        positive: resp.positive,
        negative: resp.negative
      })));
    }
    saveReportConfig(partnerId, marketId, config) {
      const req = new SaveReportConfigRequest({
        partnerId: partnerId,
        marketId: marketId,
        config: config
      });
      return this.api.saveReportConfig(req).pipe(map(() => true));
    }
    getReportConfig(partnerId, marketId) {
      const req = new GetReportConfigRequest({
        partnerId: partnerId,
        marketId: marketId
      });
      return this.api.getReportConfig(req).pipe(map(resp => resp.config));
    }
  }
  ExecutiveReportService.ɵfac = function ExecutiveReportService_Factory(t) {
    return new (t || ExecutiveReportService)(i0.ɵɵinject(ExecutiveReportApiService));
  };
  ExecutiveReportService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ExecutiveReportService,
    factory: ExecutiveReportService.ɵfac,
    providedIn: 'root'
  });
  return ExecutiveReportService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
class PagedResponse {
  constructor(results, nextCursor, hasMore) {
    this.results = results;
    this.nextCursor = nextCursor;
    if (hasMore !== undefined && hasMore !== null) {
      this.hasMore = hasMore;
    }
  }
}
class BiDirectionalPagedResponse extends PagedResponse {
  constructor(results, nextCursor, prevCursor, hasNext, hasPrev) {
    super(results, nextCursor);
    this.prevCursor = prevCursor;
    this.hasNext = hasNext;
    this.hasPrev = hasPrev;
  }
}

/**
 * Generated bundle index. Do not edit.
 */

export { BarChart, Category, Color, ConfigurationApiService, ExecutiveReportApiService, ExecutiveReportService, GetReportConfigRequest, GetReportConfigResponse, GetReportSummaryRequest, GetReportSummaryResponse, GraphMarker, HighlightItem, HighlightItemI18nEntry, HostService, LineGraph, ListActiveAppsMetadataRequest, ListActiveAppsMetadataResponse, ListActiveAppsMetadataResponseAppMetadatum, ListActiveAppsRequest, ListActiveAppsResponse, ListItem, ListReportDataPagedResponse, ListReportDataRequest, ListReportDatesRequest, ListReportDatesResponse, Point2D, ProductReportEntity, ReportConfig, ReportData, ReportDataFormat, ReportDataGrade, ReportDataRequest, ReportDataTemplateType, ReportDataWidth, ReportFrequency, SaveReportConfigRequest, WordCloudItem };
